import { graphql } from '@generated/gql';

export const FETCH_BILLING_SCHEDULE_FREQUENCY = graphql(/** GraphQL */ `
  query billingScheduleBreadcrumbFetchBillingScheduleFrequency(
    $billingScheduleId: ObjectID!
  ) {
    fetchBillingSchedule(billingScheduleId: $billingScheduleId) {
      billingSchedule {
        frequency
      }
    }
  }
`);
